export default {
  steps_introduction: "使用介绍",
  steps_report_drawings_notice: "报图须知",
  steps_quiz_of_safety_knowledge: "安全知识问答",
  steps_insurance_management_regulations: "保险管理规定",
  steps_home_contractor_service_group: "承建商服务群",
  btn_start_report_drawings: "开始报图",
  checkbox_known: "已知悉",
  btn_next: "下一步",
  btn_previous: "上一步",
  btn_submit: "提交",
  tips_wrong_answer: "回答错误",
  tips_right_answer: "回答正确",
  title_insurance_management_regulations: "展会施工人员保险管理规定",
  title_home_contractor_service_group: "承建商群二维码",
  text_qr: "二维码",
  introduction_info_1:
    "您在当前展会下第一次报图时，报图须知，安全知识问答，展会施工人员保险管理规定，及主场承建商服务群等内容为必读内容，阅读完成后，进入报图流程。",
  introduction_info_1_baima: "本功能用于展位提交报图资料，请仔细阅读报图须知。",
  introduction_info_2:
    "当您之后进入特装报图，点击页面右上角的“新增申请”按钮，开始报图。",
  introduction_info_2_baima:
    "当您之后进入特装报图，点击页面右上角的“新增申请”按钮，开始报图。",
  introduction_info_3:
    "系统支持部分资料保存，继续报图可以在“申请记录”中找到历史记录，点击“修改”按钮，继续报图。",
  introduction_info_3_baima:
    "系统支持部分资料保存，继续报图可以在“申请记录”中找到历史记录，点击“修改”按钮，继续报图。"
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/drawings/drawingsNotice.js